import { Message, QueuedMessage } from '../../types/Messaging/Message';

export function mergeSortedMessages(
  server: Message[],
  local: (Message | QueuedMessage)[]
): (Message | QueuedMessage)[] {
  // Normalize to ms timestamps once, upfront
  const toMs = (v: string | number) =>
    typeof v === 'number' ? v : Date.parse(v);

  let i = 0,
    j = 0;
  const merged: (Message | QueuedMessage)[] = [];
  const seen = new Set<Message['id'] | QueuedMessage['id']>();

  // Dedupe by id. Server messages are pushed first on ties, so a confirmed
  // server message wins over its optimistic/queued counterpart.
  const push = (msg: Message | QueuedMessage) => {
    if (msg.id != null) {
      if (seen.has(msg.id)) return;
      seen.add(msg.id);
    }
    merged.push(msg);
  };

  while (i < server.length && j < local.length) {
    const sTime = toMs(server[i].created_at);
    const lTime = toMs(local[j].created_at);

    if (sTime <= lTime) {
      push(server[i]);
      i++;
    } else {
      push(local[j]);
      j++;
    }
  }

  // Remaining server messages
  while (i < server.length) {
    push(server[i]);
    i++;
  }

  // Remaining local — skip any already confirmed
  while (j < local.length) {
    push(local[j]);
    j++;
  }

  return merged;
}
